import React from 'react'

import {Button} from '@vio/atlas/Button'
import {GenericError} from '@vio/atlas/GenericError'
import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

import {ErrorMessage} from './CrashErrorMessageContainer'

interface Props {
  t: ErrorMessage
  onButtonClick?: () => void
}

export const CrashErrorMessage = ({t, onButtonClick}: Props) => {
  const {shell} = useBrandCapabilities()

  return (
    <GenericError withIllustration={shell.hasFriendlyErrorIllustration}>
      <Box marginBottom="s300">
        <Text variant="titleXL" dataId="error-page-heading" align="center">
          {t.heading}
        </Text>
      </Box>
      <Box marginBottom="s500">
        <Text variant="bodyM">{t.message}</Text>
      </Box>
      <Button onClick={onButtonClick}>{t.button}</Button>
    </GenericError>
  )
}
